import { t as AitisalSdk } from "../../aitisal-sdk-B2mK3RTK.mjs";

//#region restaurant/sales-channel/sales-channel.ts
async function createSalesChannel(brandUUID, createSalesChannel) {
	return AitisalSdk.getInstance().post(`brands/${brandUUID}/sales-channels`, createSalesChannel);
}
async function updateSalesChannel(brandUUID, salesChannelUUID, updateSalesChannel) {
	return AitisalSdk.getInstance().patch(`brands/${brandUUID}/sales-channels/${salesChannelUUID}`, updateSalesChannel);
}
async function upsertLocationChannel(brandUUID, salesChannelUUID, locationUUID, upsertLocationChannel) {
	return AitisalSdk.getInstance().post(`brands/${brandUUID}/sales-channels/${salesChannelUUID}/locations/${locationUUID}`, upsertLocationChannel);
}
async function browseSalesChannels(brandUUID) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/sales-channels`);
}
async function browseLocationChannels(brandUUID, salesChannelUUID) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/sales-channels/${salesChannelUUID}/locations`);
}
async function deleteLocationChannel(brandUUID, salesChannelUUID, locationUUID) {
	return AitisalSdk.getInstance().delete(`brands/${brandUUID}/sales-channels/${salesChannelUUID}/locations/${locationUUID}`);
}
async function getSalesChannelByType(brandUUID, type) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/sales-channels/${type}`);
}
async function getLocationChannelByType(brandUUID, type, locationUUID) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/sales-channels/${type}/locations/${locationUUID}`);
}
async function getSalesChannelMenuAggregate(brandUUID, salesChannelUUID, locationId) {
	return AitisalSdk.getInstance().get(`brands/${brandUUID}/sales-channels/${salesChannelUUID}/menu`, { params: { locationId } });
}

//#endregion
export { browseLocationChannels, browseSalesChannels, createSalesChannel, deleteLocationChannel, getLocationChannelByType, getSalesChannelByType, getSalesChannelMenuAggregate, updateSalesChannel, upsertLocationChannel };
//# sourceMappingURL=index.mjs.map